import { InjectionToken } from '@angular/core';

// Define and use an InjectionToken object for choosing a provider token for non-class dependencies.
export const SHOULD_SESSION_STORAGE_ENCRYPT = new InjectionToken<boolean>('Encrypt the session storage or not');
